import { Link, type LinkProps } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'

interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant
  isLoading?: boolean
  children: React.ReactNode
}

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-ink text-white hover:bg-wd-orange',
  secondary: 'border border-ink/30 text-carbon hover:border-ink hover:bg-ink hover:text-white',
  ghost: 'text-carbon hover:text-wd-orange',
}

export function LinkButton({
  variant = 'primary',
  isLoading,
  children,
  className,
  ...props
}: LinkButtonProps) {
  return (
    <Link
      className={cn(
        'inline-flex items-center justify-center gap-2 px-6 py-3 text-xs font-medium normal-case tracking-[0.12em] transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wd-orange',
        variants[variant],
        className
      )}
      {...props}
    >
      {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </Link>
  )
}
